// extracted by mini-css-extract-plugin
export var root = "M_wC";
export var wrapper = "M_wD";
export var image = "M_wF d_v d_x d_V";
export var crop = "M_wG";
export var round = "M_wH";
export var fixedHeight = "M_wJ";